import React, { useEffect, useState } from 'react';
import { useGlobalData } from '../../context/GlobalDataContext';

const FAQAdminPanel = () => {
  const { faqs, loading, fetchFaqs } = useGlobalData();
    const [openIndex, setOpenIndex] = useState(null);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  // loading now comes from context
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [darkMode, setDarkMode] = useState(document.body.classList.contains('dark-mode'));
  const [editId, setEditId] = useState(null);


   useEffect(() => {
    fetchFaqs(); // page open hote hi FAQs load
  }, [fetchFaqs]);

  // Sync dark mode with Navbar
  useEffect(() => {
    const handler = () => setDarkMode(document.body.classList.contains('dark-mode'));
    window.addEventListener('darkModeChanged', handler);
    return () => window.removeEventListener('darkModeChanged', handler);
  }, []);

  // Remove local fetchFaqs and use context

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!question.trim() || !answer.trim()) {
      setError('Question and answer are required.');
      return;
    }
    try {
      let res;
      const token = localStorage.getItem('token');
      if (editId) {
        res = await fetch(`${process.env.REACT_APP_API_URL}/faq/${editId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
          },
          body: JSON.stringify({ question, answer })
        });
        if (!res.ok) throw new Error('Failed to update FAQ');
        setSuccess('FAQ updated successfully!');
      } else {
        res = await fetch(`${process.env.REACT_APP_API_URL}/faq`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
          },
          body: JSON.stringify({ question, answer })
        });
        if (!res.ok) throw new Error('Failed to add FAQ');
        setSuccess('FAQ added successfully!');
      }
      setQuestion('');
      setAnswer('');
      setEditId(null);
      await fetchFaqs(); // Refresh FAQs after add/update
    } catch (err) {
      setError(editId ? 'Error updating FAQ' : 'Error adding FAQ');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this FAQ?')) return;
    setError('');
    setSuccess('');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_URL}/faq/${id}`, {
        method: 'DELETE',
        headers: {
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }
      });
      if (!res.ok) throw new Error('Failed to delete FAQ');
      setSuccess('FAQ deleted successfully!');
      await fetchFaqs(); // Refresh FAQs after deletion
    } catch (err) {
      setError('Error deleting FAQ');
    }
  };


  const handleEdit = (faq) => {
    setEditId(faq._id);
    setQuestion(faq.question);
    setAnswer(faq.answer);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Move FAQ up or down
  const handleMove = async (id, direction) => {
    setError('');
    setSuccess('');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_URL}/faq/${id}/move`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ direction })
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to move FAQ');
      }
      setSuccess('FAQ order updated!');
      await fetchFaqs(); // Refresh FAQs after moving
    } catch (err) {
      setError(err.message || 'Error moving FAQ');
    }
  };

  // Role check for superadmin only
  const role = localStorage.getItem('role');
  if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }

  return (
    <div style={{
      maxWidth: 700,
      margin: '40px auto',
      padding: 24,
      background: darkMode ? '#181a2a' : '#fff',
      borderRadius: 8,
      boxShadow: darkMode ? '0 2px 8px rgba(0,0,0,0.32)' : '0 2px 8px rgba(0,0,0,0.08)',
      color: darkMode ? '#f1f5f9' : '#222',
      transition: 'background 0.2s, color 0.2s'
    }}>
      <h2>FAQ Admin Panel</h2>
      <form onSubmit={handleSubmit} style={{marginBottom: 32, display: 'flex', flexDirection: 'column', gap: 12}}>
        <input
          type="text"
          placeholder="Question"
          value={question}
          onChange={e => setQuestion(e.target.value)}
          style={{padding: 8, borderRadius: 4, border: '1px solid #ccc', background: darkMode ? '#23263a' : '#fff', color: darkMode ? '#f1f5f9' : '#222'}}
        />
        <textarea
          placeholder="Answer"
          value={answer}
          onChange={e => setAnswer(e.target.value)}
          rows={3}
          style={{padding: 8, borderRadius: 4, border: '1px solid #ccc', background: darkMode ? '#23263a' : '#fff', color: darkMode ? '#f1f5f9' : '#222'}}
        />
        <button type="submit" style={{background:'#007bff',color:'#fff',border:'none',borderRadius:4,padding:'8px 20px',fontWeight:600,cursor:'pointer'}}>{editId ? 'Update FAQ' : 'Add FAQ'}</button>
        {editId && (
          <button type="button" onClick={() => { setEditId(null); setQuestion(''); setAnswer(''); }} style={{background:'#888',color:'#fff',border:'none',borderRadius:4,padding:'8px 20px',fontWeight:600,cursor:'pointer',marginTop:4}}>Cancel Edit</button>
        )}
        {error && <div style={{color:'red'}}>{error}</div>}
        {success && <div style={{color:'green'}}>{success}</div>}
      </form>
      {loading && faqs.length === 0 ? <p>Loading...</p> : (
        <div>
          {faqs.length === 0 ? <p>No FAQs found.</p> : (
            <ul style={{listStyle:'none',padding:0}}>
              {faqs.map((faq, idx) => (
                <li key={faq._id} style={{marginBottom:16, padding:0, background: darkMode ? '#23263a' : '#f6f8fa', borderRadius:6, overflow:'hidden', position:'relative'}}>
                  <button
                    onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      background: 'none',
                      border: 'none',
                      padding: '16px',
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      cursor: 'pointer',
                      outline: 'none',
                      borderBottom: openIndex === idx ? '1px solid #007bff' : '1px solid #e5e7eb',
                      color: darkMode ? '#f1f5f9' : '#222'
                    }}
                  >
                    Q: {faq.question}
                  </button>
                  <div style={{display:'flex',gap:8,padding:'0 16px 8px 16px',flexWrap:'wrap'}}>
                    <button onClick={() => handleEdit(faq)} style={{background:'#ffc107',color:'#222',border:'none',borderRadius:4,padding:'4px 14px',fontWeight:600,cursor:'pointer'}}>Modify</button>
                    <button onClick={() => handleDelete(faq._id)} style={{background:'#dc3545',color:'#fff',border:'none',borderRadius:4,padding:'4px 14px',fontWeight:600,cursor:'pointer'}}>Delete</button>
                    <button
                      onClick={() => handleMove(faq._id, 'up')}
                      disabled={idx === 0}
                      style={{background:'#007bff',color:'#fff',border:'none',borderRadius:4,padding:'4px 10px',fontWeight:600,cursor:idx===0?'not-allowed':'pointer',opacity:idx===0?0.5:1}}
                    >↑ Move Up</button>
                    <button
                      onClick={() => handleMove(faq._id, 'down')}
                      disabled={idx === faqs.length - 1}
                      style={{background:'#007bff',color:'#fff',border:'none',borderRadius:4,padding:'4px 10px',fontWeight:600,cursor:idx===faqs.length-1?'not-allowed':'pointer',opacity:idx===faqs.length-1?0.5:1}}
                    >↓ Move Down</button>
                  </div>
                  {openIndex === idx && (
                    <div style={{padding:'16px', background: darkMode ? '#23263a' : '#e9ecef', color: darkMode ? '#f1f5f9' : '#333', fontSize:'1rem', whiteSpace: 'pre-line'}}>
                      <strong>A:</strong> {faq.answer}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default FAQAdminPanel;
